/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import moment from 'moment'
import 'moment-timezone'

interface Props {
  color: string
  lightColor: string
}

const StakingWeekChart: React.FC<Props> = ({ color, lightColor }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, getChartOptions(color, lightColor))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode])

  return (
    <>
      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_staking_week_chart'
        style={{ height: '300px' }}
        className='card-rounded-bottom'></div>
      {/* end::Chart */}
    </>
  )
}

function getChartOptions(color: string, lightColor: string): ApexOptions {
  return {
    series: [
      {
        name: 'พนักงานลา',
        data: [...Array(0)].map(() => Math.floor(Math.random() * 10)),
      },
      {
        name: 'เวลาสูญเสีย',
        data: [...Array(0)].map(() => Math.floor(Math.random() * 10)),
      },
      {
        name: 'เครื่องจักเสีย',
        data: [...Array(0)].map(() => Math.floor(Math.random() * 10)),
      },
    ],
    chart: {
      type: 'line',
      height: 300,
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      // curve: 'smooth',
      width: 3,
      colors: ['#FF5B5B', '#00B074', '#2D9CDB'],
    },
    colors: ['#FF5B5B', '#00B074', '#2D9CDB'],
    xaxis: {
      categories: [...Array(7)].map((_, i) =>
        moment()
          .tz('Asia/Bangkok')
          .subtract(6 - i, 'days')
          // .add(543, 'years')
          .format('DD/MM/YYYY')
      ),
    },
    fill: {
      type: 'solid',
      opacity: 1,
    },
    legend: {
      fontFamily: "'Prompt', sans-serif",
    },
    subtitle: {
      style: {
        fontFamily: "'Prompt', sans-serif",
      },
    },

    // tooltip: {
    //   custom: function ({ w, dataPointIndex, seriesIndex }) {
    //     const datas = w.globals.initialSeries
    //     const dataColor = w.globals.colors

    //     const extractedData = extractSingleBarChart(datas, dataColor, dataPointIndex, seriesIndex)

    //     return `<div class="bg-kumopack-base-black py-2 px-5 text-kumopack-base-white">
    // 						    <div>${formatNumberCommas(extractedData.total)} users</div>
    // 					</div>`
    //   },
    // },
  }
}

export default StakingWeekChart
